import { z } from 'zod';

import { customErrorMap, ERRORS } from './Error.uiCopy';
import { SelectOptionSchema } from './shared';

z.setErrorMap(customErrorMap);

export const NewSMSNumbersSchema = z.object({
  sandbox: z
    .string({
      required_error: ERRORS.required,
    })
    .min(1, ERRORS.required)
    .max(100, ERRORS.max(100)),
  preRelease: z
    .string({
      required_error: ERRORS.required,
    })
    .min(1, ERRORS.required)
    .max(100, ERRORS.max(100)),
  live: z
    .string({
      required_error: ERRORS.required,
    })
    .min(1, ERRORS.required)
    .max(100, ERRORS.max(100)),
});

export const NewSMSSchema = z.object({
  name: z
    .string({
      required_error: ERRORS.required,
    })
    .min(1, ERRORS.required)
    .max(100, ERRORS.max(100)),
  text: z
    .string({
      required_error: ERRORS.required,
    })
    .min(1, ERRORS.required)
    .max(500, ERRORS.max(500)),
  envPhoneNumbers: SelectOptionSchema.transform(v => ({
    sandbox: '',
    preRelease: '',
    live: v.value,
  })),
});
